<template>
  <div>
    <SiteHero
      pageTitle="Contact"
      pageDescription="Reach out to us for any questions or inquiries."
    />

    <div class="page-content">
      <p>Contact</p>
      <ContactForm />
    </div>

    <SiteFooter />
  </div>
</template>

<script>
  import ContactForm from '../components/Contact/ContactForm.vue';
  import SiteFooter from '../components/Footer/SiteFooter.vue';
  import '../assets/styles/page.css';
  import SiteHero from '../components/Hero/SiteHero.vue';

  export default {
    name: 'ContactPage',
    components: {
      ContactForm,
      SiteFooter,
      SiteHero,
    },
  };
</script>
